module.exports = __webpack_public_path__ + "static/img/bg39.a75053ec.png";